import { render } from "./Task_calendar.vue?vue&type=template&id=781dce79&scoped=true"
import script from "./Task_calendar.vue?vue&type=script&lang=js"
export * from "./Task_calendar.vue?vue&type=script&lang=js"

import "./Task_calendar.vue?vue&type=style&index=0&id=781dce79&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-781dce79"]])

export default __exports__